import * as React from 'react';
import { ExperimentContextProvider } from './Experiment.js';
import { Direction, LocaleContextProvider } from './Locale.js';
import { PlatformContextProvider } from './Platform.js';
import { ThemeContextProvider } from './Theme.js';

var AdsSessionContextProvider = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children,
    _ref$value = _ref.value,
    _ref$value$locale = _ref$value.locale,
    locale = _ref$value$locale === void 0 ? 'en-us' : _ref$value$locale,
    _ref$value$direction = _ref$value.direction,
    direction = _ref$value$direction === void 0 ? Direction.LTR : _ref$value$direction,
    platform = _ref$value.platform,
    experiment = _ref$value.experiment,
    theme = _ref$value.theme;
  return /*#__PURE__*/React.createElement(ExperimentContextProvider, {
    value: experiment
  }, /*#__PURE__*/React.createElement(LocaleContextProvider, {
    value: {
      locale: locale,
      direction: direction
    }
  }, /*#__PURE__*/React.createElement(PlatformContextProvider, {
    value: {
      platform: platform
    }
  }, /*#__PURE__*/React.createElement(ThemeContextProvider, {
    cssArchitecture: experiment.cssArchitecture,
    deprecateInaccessibleColor: experiment.deprecateInaccessibleColor,
    value: theme
  }, children))));
});
AdsSessionContextProvider.displayName = 'AdsSessionContextProvider';

export { AdsSessionContextProvider };
//# sourceMappingURL=AdsSessionContextProvider.js.map
